import { render, staticRenderFns } from "./ScanChoice.vue?vue&type=template&id=1d10be02"
import script from "./ScanChoice.vue?vue&type=script&lang=js"
export * from "./ScanChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports